import { useEffect } from "react";

interface ReleaseNote {
  version: string;
  notes: React.ReactNode[];
  date: string;
}

interface Props {
  onDismiss: () => void;
  releaseNotes: ReleaseNote;
}

const ReleaseNotesModal = ({ onDismiss, releaseNotes }: Props) => {
  // This effect disables scrolling on the body when the modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  return (
    <>
      <div
        className="modal show d-block"
        tabIndex={-1}
        onClick={(e) => {
          if (e.target === e.currentTarget) onDismiss();
        }}
      >
        <div className="modal-dialog" style={{ marginTop: "30vh" }}>
          <div className="modal-content">
            <div className="modal-header border-0 pb-0">
              <div className="d-flex justify-content-between align-items-center w-100">
                <h3 className="m-0">New Version Released! 🎉</h3>
                <span className="badge bg-primary">
                  v{releaseNotes.version}
                </span>
              </div>
            </div>
            <div className="modal-body pt-2">
              <div className="mb-3">
                <small className="text-muted">
                  Released on {releaseNotes.date}
                </small>
              </div>
              <h5>What's New:</h5>
              <ul className="list-group list-group-flush mb-4">
                {releaseNotes.notes.map((note, index) => (
                  <li key={index} className="list-group-item px-0">
                    {note}
                  </li>
                ))}
              </ul>
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onDismiss}
                >
                  Got it!
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop show" />
    </>
  );
};

export default ReleaseNotesModal;
